import { render, staticRenderFns } from "./ProgresoImpresionTab.vue?vue&type=template&id=582293ad&"
import script from "./ProgresoImpresionTab.vue?vue&type=script&lang=js&"
export * from "./ProgresoImpresionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports